import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hfw2t2ygt4: FaireBrandEntity = {
  token: "b_hfw2t2ygt4",
  type: "brand",
  name: "Southern Designs by Kristy",
  avatarUrl:
    "https://cdn.faire.com/fastly/5762e6f2f41388252a95b07b524d4a1bd113c91868ba8a2ffea2ba7e15db7fb7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2102f62e109149b66717116e68654e3978257a421289f831b64e8404cbc1565a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5762e6f2f41388252a95b07b524d4a1bd113c91868ba8a2ffea2ba7e15db7fb7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2102f62e109149b66717116e68654e3978257a421289f831b64e8404cbc1565a.jpeg",
  location: "Hernando, MS, USA",
  minimumOrderDollars: 35,
  rating: 4.8,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "At Southern Designs by Kristy, we believe that jewelry and home essentials should be more than just beautiful they should be meaningful. Each piece in our collection is thoughtfully curated and carefully crafted to reflect timeless elegance with a fresh, modern Southern spirit.\n\nOur luxe home fragrances and everyday essentials invite warmth and comfort into your living space, creating a sanctuary that feels uniquely yours.\n\nWith a passion for quality and a love for Southern charm, we blend sophistication and comfort seamlessly. Southern Designs by Kristy isn’t just a brand it’s an invitation to celebrate your story with pieces that resonate, inspire, and stand the test of time.\n\nBecause here, beauty tells your story.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:34.261Z",
    importedBy: "entity-db-cli",
  },
};
